import { Textarea as ChakraTextarea, TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';

interface TextareaProps
  extends ChakraTextareaProps,
    Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'color'> {
  maxExpandHeight?: number;
}

const Textarea = ({ maxExpandHeight, ...props }: TextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const adjustTextareaHeight = (maxExpandHeight: number) => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, maxExpandHeight)}px`;
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange?.(e);
    if (maxExpandHeight) {
      adjustTextareaHeight(maxExpandHeight);
    }
  };

  useEffect(() => {
    if (maxExpandHeight) {
      adjustTextareaHeight(maxExpandHeight);
    }
  }, [props.value]);

  return (
    <>
      <ChakraTextarea {...props} ref={textareaRef} onChange={onChange} />
    </>
  );
};

export default Textarea;
